import { checkoutSlice, orderSlice, wizardSlice } from './slices';

export const checkout = checkoutSlice.actions;
export const order = orderSlice.actions;
export const wizard = wizardSlice.actions;
